import { useNavigate } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Popconfirm, Popover } from "antd";

import { showModal } from "@/store/slices/modalSlice";
import { userReset } from "@/features/user/duck/user";
import { hideModal } from "@/store/slices/modalSlice";
import { logout } from "@/features/auth/duck/auth";
import Button from "@/common/atoms/Button";
import ChangePassword from "@/features/auth/changePassword/changePassword";
import { popoverNavItems } from "@/constants/miscConstants";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { resetAiChatBot } from "@/features/aiAgentChatBot/duck/aiChatBot";

const ProfilePopover = ({ visible, setVisibility, placement }) => {
  const { userInfo } = useSelector((state) => state.user, shallowEqual);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      if (visible) {
        setVisibility(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [visible, setVisibility]);

  const onHideModal = (item) => {
    setVisibility(!visible);
    if (item) {
      navigate(`${item.to}`);
    }
    dispatch(hideModal());
  };

  const handleVisibleChange = (visibility) => {
    setVisibility(visibility);
  };

  const onLogoutHandler = () => {
    dispatch(resetAiChatBot());
    dispatch(logout());
    setVisibility(!visible);
    dispatch(userReset());
    navigate("/");
    onHideModal();
  };

  const onChangePasswordHandler = () => {
    setVisibility(!visible);
    dispatch(
      showModal({
        content: <ChangePassword />,
        classes: "change-password-modal-container"
      })
    );
  };

  const content = (
    <div>
      <div className="flex flex-col ml-2 w-40">
        <ul>
          {popoverNavItems?.map((item, index) =>
            !item.isButton ? (
              <div
                className="cursor-pointer"
                onClick={() => onHideModal(item)}
                key={`${t(item.name)}-${index}`}>
                <div
                  className={
                    index != popoverNavItems.length - 1 ? "border-b-2" : ""
                  }>
                  <li className=" md:py-4 py-[10px] hover:text-primary">
                    {t(item.name)}
                  </li>
                </div>
              </div>
            ) : (
              <div
                className="cursor-pointer"
                onClick={onChangePasswordHandler}
                key={`${t(item.name)}-${index}`}>
                <div
                  className={
                    index != popoverNavItems.length - 1 ? "border-b-2" : ""
                  }>
                  <li className=" md:py-4 py-[10px] hover:text-primary">
                    {t(item.name)}
                  </li>
                </div>
              </div>
            )
          )}
        </ul>
      </div>

      <div className="flex flex-col items-center justify-center">
        <Popconfirm
          title={t("header.logoutConfirmation")}
          okText={t("common.yes")}
          cancelText={t("common.no")}
          placement="bottom"
          onConfirm={onLogoutHandler}>
          <div>
            <Button className="w-40 center m-2 h-12">
              {t("header.logout")}
            </Button>
          </div>
        </Popconfirm>
      </div>
    </div>
  );

  return (
    <Popover
      content={content}
      title={
        userInfo?.firstName && (
          <div className="font-kindAvenue text-secondary text-xl capitalize">
            {`${userInfo?.firstName} ${userInfo?.lastName} `}
          </div>
        )
      }
      trigger="click"
      open={visible}
      onOpenChange={handleVisibleChange}
      placement={placement}
    />
  );
};

export default ProfilePopover;
